export default __webpack_public_path__ + "static/media/playing-card.be274e16.png";